var _defaultValues;
import { NAME, EMAIL, MESSAGE } from "./field-names";
export var defaultValues = (_defaultValues = {}, _defaultValues[NAME] = "", _defaultValues[EMAIL] = "", _defaultValues[MESSAGE] = "", _defaultValues);
